<template>
    <ReactPage>
      <chest-prize-report-page></chest-prize-report-page>
    </ReactPage>
  </template>
  
  <script>
  import ReactPage from '../components/ReactPage.vue';
  
  export default {
    name: "ChestPrizeReport",
    components: {
      ReactPage
    }
  }
  </script>